// Debouncer, jQuery

window.themeJs = themeJs || {};


( function($) {

    $('document').ready(function () {

        const header = '.site-header';
        let $topOfDoc = $('.site-inner, .site-hero');

        if($topOfDoc.length > 1) {
            // get first element in DOM
            $topOfDoc = $($topOfDoc[0]);
        }
        let topOfDocMargin = '0px';
        if($topOfDoc.length === 1) {
            topOfDocMargin = $topOfDoc.css('margin-top');
        } else {
            $topOfDoc = false;
        }

        const $w = $(window);
        const $body = $('body');
        const breakpoint = 992;  //breakpoint in pixels when page is in 'mobile' mode/version.  Used if fixed header not wanted on mobile version.

        let shifted = false;
/*

        if ( $body[0].getBoundingClientRect().right >= breakpoint && $w.scrollTop() <= 30) { //checking if page is loaded shifted
            shifted = true;
        }
*/


        function onScrollFunction() {

            if ( $body[0].getBoundingClientRect().right >= breakpoint ) {
                if (!shifted && $w.scrollTop() > 30) {

                    $body.addClass('scrolled');

                    // get height of site header and add top margin to toOfDoc

                    const height = $(header).height() + 0;

                    if($topOfDoc !== false ) {
                        $topOfDoc.css('marginTop', height + 'px');
                    }

                    shifted = true;

                } else if (shifted && $w.scrollTop() <= 30) {
                    if($topOfDoc !== false ) {
                        $topOfDoc.css('marginTop', topOfDocMargin);
                    }
                    $body.removeClass('scrolled');

                    shifted = false;

                }
            }
        }

        function onResizeFunction() {

            if(shifted && $body[0].getBoundingClientRect().right <= breakpoint) {
                if($topOfDoc !== false) {
                    $topOfDoc.css('marginTop', topOfDocMargin);
                }
                $body.removeClass('scrolled');

                shifted = false;
            }
        }

        let debouncedScroll = new themeJs.Debouncer(onScrollFunction);
        let debouncedResize = new themeJs.Debouncer(onResizeFunction);

        onScrollFunction(); //run on page load since can load in the middle of page

        window.addEventListener('scroll', debouncedScroll.handleEvent.bind(debouncedScroll));
        window.addEventListener('resize', debouncedResize.handleEvent.bind(debouncedResize));


    });
})(jQuery);
